import LoadingButton from "@mui/lab/LoadingButton";
import {
  Autocomplete,
  Box,
  Button,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  Checkbox,
  Chip,
  Collapse,
  Container,
  Dialog,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grow,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Tooltip,
  Typography,
  Zoom,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { useContext, useEffect, useState } from "react";
import PayrollList from "./PayrollList";
import {
  Add,
  CheckBox,
  Checklist,
  Close,
  Edit,
  Filter,
  Payment,
  Receipt,
  Save,
  Visibility,
} from "@mui/icons-material";
import { green } from "@mui/material/colors";
import axios from "axios";
import { useFormik } from "formik";
import * as Yup from "yup";
import { DataContext } from "../InitHrm";
import { BaseHrmUrl } from "../../Intro/Constants";

function Payroll() {
  const [openPayrollSetting, setPayrollSetting] = useState(false);
  const [payrollLoading, setPayrollLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [dialogueContent, setDialogContent] = useState(null);
  const [deductions, setDeduction] = useState(null);
  const [payrolls, setPayrolls] = useState(null);

  useEffect(()=>{async function loadData() {
    try {
      const response = await axios.get(`${BaseHrmUrl}/deduction`);
      if (response.status === 200) {
        setDeduction(response.data);
        
      } else {
        alert("Failed! Try again.");
      }
    } catch (error) {
      alert("Error fetching deductions, No internet?");
    }
  };
loadData();}, [])
useEffect(()=>{async function loadData() {
  try {
    const response = await axios.get(`${BaseHrmUrl}/payroll`);
    if (response.status === 200) {
      setPayrolls(response.data);
      console.log(payrolls);
      
    } else {
      alert("Failed! Try again.");
    }
  } catch (error) {
    alert("Error fetching payrolls, No internet?");
  }
};
loadData();}, [])

  const handleRunPayroll = () => {
    setPayrollSetting(true);
  };

  const handleGeneratePayroll = () => {
    setPayrollLoading(true);
  };
  const handleDeductions = () => {};
  const handlePayslips = () => {
    setPayrollLoading(true);
  };

  const handleListPayroll = () => {};


  const handleAddDeduction = () => {
    setOpen(true);
    setDialogContent(<AddDeduction setOpen={setOpen} />);
  };
  const handleNewPayroll = () => {
    setOpen(true);
    setDialogContent(<CreatePayroll setOpen={setOpen} />);
  };
  return (
    <>
      <Zoom in={true} style={{ transitionDelay: "200ms" }}>
        <Stack>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            Payroll
          </Typography>
          <Divider variant="middle" />
          <Box
            display={"flex"}
            mt={2}
            columnGap={2}
            justifyContent={"space-evenly"}
          >
            <Stack width={"63%"}>
              <Box display={"flex"} mt={1} columnGap={2} alignItems={"center"}>
                <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                  Payrolls
                </Typography>
                <Tooltip title="new payroll">
                  <IconButton sx={{ ml: "auto" }} onClick={handleNewPayroll}>
                    <Add />
                  </IconButton>
                </Tooltip>
              </Box>
              <Divider />
              <Card sx={{ mt: 1 }}>
                <CardContent>
                  {payrolls ? (
                    <List style={{ maxHeight: "70vh", overflow: "auto" }}>
                      {payrolls.map((payroll) => {
                        return (
                          <ListItem key={payroll.id}>
                            <ListItemButton
                              sx={{ borderRadius: 4, bgcolor: green[200] }}
                              onClick={() => {
                                setOpen(true);
                                setDialogContent(
                                  <PayrollContent
                                    payroll={payroll}
                                    close={setOpen}
                                  />
                                );
                              }}
                            >
                              <ListItemText
                                primary={
                                  <Box display={"flex"}>
                                    <Typography
                                      variant="body1"
                                      sx={{ fontWeight: "bold" }}
                                    >
                                      {payroll.from_date} to {payroll.to_date}
                                    </Typography>{" "}
                                    <Chip
                                      sx={{ ml: "auto" }}
                                      label={payroll.status==="true"?"paid":"pending"}
                                      color={
                                        payroll.status === "true"
                                          ? "success"
                                          : "error"
                                      }
                                    />{" "}
                                  </Box>
                                }
                              />
                            </ListItemButton>
                          </ListItem>
                        );
                      })}
                    </List>
                  ) : (
                    <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                      No payrolls created yet!
                    </Typography>
                  )}
                </CardContent>
              </Card>
            </Stack>
            <Divider flexItem orientation="vertical" />
            <Stack width={"35%"}>
              <Box display={"flex"} mt={1} columnGap={2} alignItems={"center"}>
                <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                  Deductions
                </Typography>
                <Tooltip title="add deduction">
                  <IconButton sx={{ ml: "auto" }} onClick={handleAddDeduction}>
                    <Add />
                  </IconButton>
                </Tooltip>
              </Box>

              <Divider />
              {deductions ? (
                <Card sx={{ mt: 1 }}>
                  <CardContent>
                    <List style={{ maxHeight: "70vh", overflow: "auto" }}>
                      {deductions.map((deduction) => {
                        return (
                          <ListItem key={deduction.id}>
                            <ListItemButton
                              sx={{ borderRadius: 4 }}
                              onClick={() => {
                                setOpen(true);
                                setDialogContent(
                                  <Deductions
                                    deduction={deduction}
                                    close={setOpen}
                                  />
                                );
                              }}
                            >
                              <ListItemText
                                primary={
                                  <Box display={"flex"}>
                                    <Typography
                                      variant="body1"
                                      sx={{ fontWeight: "bold" }}
                                    >
                                      {deduction.deduction_name}
                                    </Typography>
                                    <Typography
                                      variant="body1"
                                      ml={"auto"}
                                      sx={{ fontWeight: "bold" }}
                                    >
                                      {deduction.deduction_type === "amount"
                                        ? "Ksh. "
                                        : null}
                                      {deduction.amount}
                                      {deduction.deduction_type === "percent"
                                        ? "%"
                                        : null}
                                    </Typography>
                                  </Box>
                                }
                              />
                            </ListItemButton>
                          </ListItem>
                        );
                      })}
                    </List>
                  </CardContent>
                </Card>
              ) : (
                <Box
                  display={"flex"}
                  justifyContent={"center"}
                  alignItems={"center"}
                  mt={2}
                >
                  <Typography variant="body1">No deductions added</Typography>
                </Box>
              )}
            </Stack>
          </Box>
          <Dialog
            open={open}
            onClose={() => setOpen(false)}
            fullWidth
            maxWidth="md"
          >
            {dialogueContent}
          </Dialog>
        </Stack>
      </Zoom>
    </>
  );
}

export default Payroll;

function PayrollContent(props) {
  const { payroll, close } = props;

  return (
    <Grow in={true} timeout={"200ms"} unmountOnExit>
      <Card elevation={2}>
        <CardContent>
          <Box display={"flex"} mt={1} columnGap={2} alignItems={"center"}>
            <Typography variant="body1" sx={{fontWeight:'bold'}}>
              Payroll as from {payroll.from_date} to {payroll.to_date}
            </Typography>
            <Button
              sx={{ ml: "auto" }}
              startIcon={<Close />}
              size="small"
              color="error"
              onClick={() => close(false)}
            ></Button>
          </Box>

          <Divider variant="middle" />

          <Box display={"flex"} mt={1} columnGap={2}>
            <Typography>
              <Chip label="Gross Amount paid" /> 1000000
            </Typography>
            <Typography ml={"auto"}>
              <Chip label="Net Amount paid" /> 999000
            </Typography>
          </Box>
          <Box display={"flex"} mt={1}>
            <Typography>
              <Chip label="Total Deductions" /> 1000
            </Typography>
            <Typography ml={"auto"}>
              <Chip label="Account" /> Salaries
            </Typography>
          </Box>
          <Box display={"flex"} mt={1}>
            <Typography>
              <Chip label="Employees Paid" /> 159
            </Typography>
          </Box>
        </CardContent>
        <CardActions sx={{ justifyContent: "space-evenly" }}>
          <Button
            startIcon={<Payment />}
            variant="contained"
            size="small"
            sx={{ borderRadius: 4 }}
            disabled={payroll.status == "paid" ? true : false}
            onClick={() => {}}
          >
            Initiate Payment
          </Button>
          <Button
            startIcon={<Receipt />}
            variant="contained"
            size="small"
            sx={{ borderRadius: 4 }}
            onClick={() => {}}
            disabled={payroll.status == "paid" ? false : true}
          >
            Payslips
          </Button>
          <Button
            startIcon={<Visibility />}
            variant="contained"
            size="small"
            sx={{ borderRadius: 4 }}
            onClick={() => {}}
          >
            View
          </Button>
        </CardActions>
      </Card>
    </Grow>
  );
}

function Deductions(props) {
  const { deduction, close } = props;

  const [openEdit, setOpenEdit] = useState(false);
  const [disabled, setDisabled] = useState(true);

  return (
    <Grow in={true} timeout={"200ms"} unmountOnExit>
      <Card elevation={2}>
        <CardContent>
          <Box display={"flex"} mt={1} columnGap={2} alignItems={"center"}>
            <Typography variant="h6">Details</Typography>
            <Button
              sx={{ ml: "auto" }}
              startIcon={<Close />}
              size="small"
              color="error"
              onClick={() => close(false)}
            ></Button>
          </Box>

          <Divider variant="middle" />
          <Box display={"flex"} mt={1} columnGap={2} alignItems={"center"}>
            <Chip label={deduction.deduction_name} />

            <Typography ml={"auto"}>
              Amount <Chip label={deduction.amount} />
            </Typography>
          </Box>
          <Collapse in={openEdit} timeout="auto" unmountOnExit>
            <Box display={"flex"} mt={1} columnGap={2} alignItems={"center"}>
              <TextField label="Title" value={deduction.title} size="small" />
              <TextField
                label="Amount"
                value={deduction.amount}
                size="small"
                sx={{ ml: "auto" }}
              />
            </Box>
          </Collapse>
        </CardContent>
        <CardActions sx={{ justifyContent: "space-evenly" }}>
          <Button
            startIcon={<Edit />}
            variant="contained"
            size="small"
            onClick={() => {
              setOpenEdit(true);
              setDisabled(false);
            }}
          >
            Edit
          </Button>
          <Button
            startIcon={<Save />}
            variant="contained"
            size="small"
            disabled={disabled}
          >
            save
          </Button>
        </CardActions>
      </Card>
    </Grow>
  );
}

function AddDeduction(props) {
  const { setOpen } = props;
  const [value, setValue] = useState("amount");
  const [optional, setOptional] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  

  const context = useContext(DataContext);   

 async function addDeductions(data){
      try {
        const response = await axios.post(
          `${BaseHrmUrl}/deduction`,
          { ...data, deduction_type: value, optional: optional },
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );

        if (response.status === 201) {
          setSubmitLoading(false);
          setOpen(false);
          alert("Deduction added successfully");
        } else {
          setSubmitLoading(false);
          setOpen(false);
          alert("Failed! Try again.");
        }
      } catch (error) {
        setSubmitLoading(false);
        setOpen(false);
        alert(error);
      }
    }  
   

  const deForm = useFormik({
    initialValues: {
      key: context.token,
      title: "",
      description: "",
      amount: "",
    },
    validationSchema: Yup.object({
      title: Yup.string()
        .required("Required")
        .min(3, "must be more than 3 characters"),
      description: Yup.string(),
      amount: Yup.number().required(),
    }),

    onSubmit: (values) => {
      setSubmitLoading(true);
      addDeductions(values);
    },
  });
  return (
    <Zoom in={true} style={{ transitionDelay: "200ms" }}>
      <Stack>
        <Card elevation={3}>
          <CardContent>
            <form onSubmit={deForm.handleSubmit}>
              <Stack rowGap={2}>
                <Box display={"flex"} alignItems={"center"}>
                  <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                    Add Deduction
                  </Typography>
                  <IconButton
                    color="error"
                    sx={{ ml: "auto" }}
                    onClick={() => setOpen(false)}
                  >
                    <Close />
                  </IconButton>
                </Box>
                <Divider />

                <Stack>
                  <TextField
                    label="Title"
                    size="small"
                    name="title"
                    id="title"
                    value={deForm.values.title}
                    onChange={deForm.handleChange}
                    onBlur={deForm.handleBlur}
                  />
                  {deForm.errors.title && deForm.touched.title ? (
                    <Typography>{deForm.errors.title}</Typography>
                  ) : null}
                </Stack>
                <Stack>
                  <TextField
                    label="Description"
                    size="small"
                    name="description"
                    id="description"
                    value={deForm.values.description}
                    onChange={deForm.handleChange}
                    onBlur={deForm.handleBlur}
                  />
                  {deForm.errors.description && deForm.touched.description ? (
                    <Typography>{deForm.errors.description}</Typography>
                  ) : null}
                </Stack>

                <FormControl>
                  <FormLabel id="choose_rate">Deduction Type</FormLabel>
                  <RadioGroup
                    row
                    aria-labelledby="choose_rate_rate"
                    name="choose_rate_rate_"
                    value={value}
                    onChange={(evnt, value) => setValue(value)}
                  >
                    <FormControlLabel
                      value="amount"
                      control={<Radio />}
                      label="Fixed amount"
                    />
                    <FormControlLabel
                      value="percent"
                      control={<Radio />}
                      label="Percent"
                    />
                  </RadioGroup>
                </FormControl>
                <Stack>
                  <TextField
                    label="Value"
                    size="small"
                    name="amount"
                    id="amount"
                    value={deForm.values.amount}
                    onChange={deForm.handleChange}
                    onBlur={deForm.handleBlur}
                  />
                  {deForm.errors.value && deForm.touched.value ? (
                    <Typography>{deForm.errors.value}</Typography>
                  ) : null}
                </Stack>
                <Box display={"flex"}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        onChange={(e) => {
                          setOptional(e.target.checked);
                        }}
                      />
                    }
                    label="Optional"
                  />
                </Box>

                <LoadingButton
                  loading={submitLoading}
                  variant="outlined"
                  sx={{ borderRadius: 4 }}
                  type="submit"
                >
                  submit
                </LoadingButton>
              </Stack>
            </form>
          </CardContent>
        </Card>
      </Stack>
    </Zoom>
  );
}

function CreatePayroll(props) {
  const [start_date, setStartDate] = useState(null);
  const [end_date, setEndDate] = useState(null);
  const [value, setValue] = useState("all");
  const [openMore, setOpenMore] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [branches, setBranches] = useState([]);
  const [departs, setDeparts] = useState([]);
  const [sections, setSections] = useState([]);
  const [disableDate, setDisableDate] = useState(true);
  const { setOpen } = props;
  const [createLoading, setCreateLoading] = useState(false);


  const context = useContext(DataContext)
  const token = context.token
  async function postData() {
    setCreateLoading(true);
    try {
      const response = await axios.post(
        `${BaseHrmUrl}/payroll`,
        { start: start_date.toString(), end: end_date.toString(), token: token },
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );

      if (response.status === 201) {
        setCreateLoading(false);
        setOpen(false);
        alert("Payroll added successfully");
      } else {
        setCreateLoading(false);
        setOpen(false);
        alert("Failed! Try again.");
      }
    } catch (error) {
      setCreateLoading(false);
      setOpen(false);
      alert("Error trying to fetch, No Internet?");
    }
  }

  return (
    <Zoom in={true} style={{ transitionDelay: "200ms" }}>
      <Stack>
        <Card elevation={3}>
          <CardContent>
            <Box display={"flex"} mt={1} columnGap={2} alignItems={"center"}>
              <Typography variant="h6">Create a payroll</Typography>
              <Button
                sx={{ ml: "auto" }}
                startIcon={<Close />}
                size="small"
                color="error"
                onClick={() => setOpen(false)}
              ></Button>
            </Box>
            <Divider />
            <Stack rowGap={2}>
              <Box display={"flex"} alignItems={"center"}>
                <Stack display={"flex"} alignItems={"center"}>
                  <Typography variant="body1">Starting</Typography>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Container components={["DatePicker"]}>
                      <DatePicker
                        value={start_date}
                        onChange={(newValue) => {
                          setStartDate(newValue);
                          setDisableDate(false);
                        }}
                        slotProps={{
                          textField: {
                            size: "small",
                          },
                        }}
                        disableFuture={true}
                      />
                    </Container>
                  </LocalizationProvider>
                </Stack>
                <Stack display={"flex"} alignItems={"center"}>
                  <Typography variant="body1">Ending</Typography>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Container components={["DatePicker"]}>
                      <DatePicker
                        value={end_date}
                        onChange={(newValue) => setEndDate(newValue)}
                        slotProps={{
                          textField: {
                            size: "small",
                          },
                        }}
                        disableFuture={true}
                        disabled={disableDate}
                        minDate={start_date}
                      />
                    </Container>
                  </LocalizationProvider>
                </Stack>
              </Box>
              <TextField size="small" label="Description" />
              <Collapse in={openMore} timeout="auto" unmountOnExit>
                <Stack>
                  <FormControl>
                    <FormLabel id="choose_rate">Working time</FormLabel>
                    <RadioGroup
                      row
                      aria-labelledby="choose_rate_rate"
                      name="choose_rate_rate_"
                      value={value}
                      onChange={(evnt) => setValue(evnt.target.value)}
                    >
                      <FormControlLabel
                        value="all"
                        control={<Radio />}
                        label="All"
                      />
                      <FormControlLabel
                        value="normal"
                        control={<Radio />}
                        label="Normal Time"
                      />
                      <FormControlLabel
                        value="ot"
                        control={<Radio />}
                        label="Overtime"
                      />
                    </RadioGroup>
                  </FormControl>
                  <Grid container spacing={2}>
                    <Grid item size={6}>
                      <Autocomplete
                        disablePortal
                        options={companies}
                        // onChange={(e, val) => handleBranchClick(val)}
                        sx={{ width: 300 }}
                        renderInput={(params) => (
                          <TextField {...params} label="Company" size="small" />
                        )}
                      />
                    </Grid>
                    <Grid item size={6}>
                      <Autocomplete
                        disablePortal
                        options={branches}
                        // onChange={(e, val) => handleBranchClick(val)}
                        sx={{ width: 300 }}
                        renderInput={(params) => (
                          <TextField {...params} label="Branch" size="small" />
                        )}
                      />
                    </Grid>
                    <Grid item size={6}>
                      <Autocomplete
                        disablePortal
                        options={departs}
                        // onChange={(e, val) => handleBranchClick(val)}
                        sx={{ width: 300 }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Department"
                            size="small"
                          />
                        )}
                      />
                    </Grid>
                    <Grid item size={6}>
                      <Autocomplete
                        disablePortal
                        options={sections}
                        // onChange={(e, val) => handleBranchClick(val)}
                        sx={{ width: 300 }}
                        renderInput={(params) => (
                          <TextField {...params} label="Section" size="small" />
                        )}
                      />
                    </Grid>
                  </Grid>
                </Stack>
              </Collapse>
              <Button
                size="small"
                variant="outlined"
                type="submit"
                sx={{ borderRadius: 4 }}
                loading={createLoading}
                onClick={() => setOpenMore(!openMore)}
              >
                {openMore ? "less settings" : "more settings"}
              </Button>
              <LoadingButton
                size="small"
                variant="outlined"
                type="submit"
                sx={{ borderRadius: 4 }}
                loading={createLoading}
                onClick={ postData }
              >
                Create
              </LoadingButton>
            </Stack>
          </CardContent>
        </Card>
      </Stack>
    </Zoom>
  );
}
